/* src/components/Groups.js - v3.0 - Guest Safe */
import React, { useState, useEffect } from 'react';

function Groups({ user, onNavigateGroup, onTriggerLogin }) {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [newGroupName, setNewGroupName] = useState('');
  const [newGroupDesc, setNewGroupDesc] = useState('');

  const fetchGroups = async () => {
    try {
      const res = await fetch('/api/groups');
      if (res.ok) {
        const data = await res.json();
        setGroups(data);
      }
    } catch (e) {
      console.error("Failed to load groups", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGroups();
  }, []);

  const handleCreateGroup = async () => {
      if (!newGroupName.trim()) return alert("Group name is required");

      try {
          const res = await fetch('/api/groups', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                  name: newGroupName,
                  description: newGroupDesc,
                  creator: user.name 
              })
          });

          if (res.ok) {
              const data = await res.json();
              setShowCreateModal(false);
              setNewGroupName('');
              setNewGroupDesc('');
              fetchGroups(); 
              if (data.slug) onNavigateGroup(data.slug);
          } else {
              alert("Failed to create group.");
          }
      } catch (e) {
          console.error("Creation error", e);
      }
  };

  if (loading) return <div style={{ padding: '40px', textAlign: 'center', color: '#888' }}>Loading Communities...</div>;

  return (
    <div className="feed-container">
      <div className="card" style={{ marginBottom: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 20px', minHeight: '50px' }}>
        <h2 
            style={{ margin: 0, cursor: 'pointer', fontSize: '1.2rem' }} 
            onClick={() => window.location.reload()}
            title="Reload Page"
        >
            Communities
        </h2>
        
        {/* Guest Guard: Show button but trigger login if clicked as guest */}
        <button 
            onClick={() => user ? setShowCreateModal(true) : (onTriggerLogin && onTriggerLogin())} 
            style={{ background: '#2ed573', color: 'white', border: 'none', padding: '5px 15px', borderRadius: '20px', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.9rem' }}
        >
            + Create Group
        </button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '10px' }}>
        {groups.map(group => (
          <div key={group.id} className="card" style={{ padding: 0, overflow: 'hidden', cursor: 'pointer', transition: 'transform 0.2s' }} onClick={() => onNavigateGroup(group.slug)}>
            <div style={{ height: '80px', background: group.banner_url ? `url(${group.banner_url}) center/cover` : 'linear-gradient(45deg, #1e90ff, #2ed573)' }}></div>
            <div style={{ padding: '20px', textAlign: 'center', marginTop: '-40px' }}>
              <div style={{ width: '70px', height: '70px', borderRadius: '15px', background: '#333', margin: '0 auto 10px', border: '4px solid #2b2b36', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                 {group.icon_url ? <img src={group.icon_url} alt="icon" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <span style={{ fontSize: '30px' }}>👥</span>}
              </div>
              <h3 style={{ margin: '0 0 5px 0' }}>{group.name}</h3>
              <p style={{ fontSize: '0.85rem', color: '#aaa', height: '40px', overflow: 'hidden' }}>{group.description || "No description."}</p>
              
              <div style={{ marginTop: '15px', fontSize: '0.8rem', color: '#777' }}>
                  {group.member_count} Member{group.member_count !== 1 && 's'}
              </div>
            </div>
          </div>
        ))}
      </div>

      {showCreateModal && user && (
          <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.85)', zIndex: 3000, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div className="card" style={{ width: '90%', maxWidth: '400px', padding: '30px' }}>
                  <h3 style={{ marginTop: 0 }}>Create a New Community</h3>
                  
                  <label style={{ display: 'block', marginBottom: '10px', color: '#ccc', fontSize: '0.9rem' }}>Group Name</label>
                  <input 
                    className="post-input" 
                    value={newGroupName} 
                    onChange={(e) => setNewGroupName(e.target.value)} 
                    placeholder="e.g. React Developers"
                    autoFocus
                  />

                  <label style={{ display: 'block', marginTop: '15px', marginBottom: '10px', color: '#ccc', fontSize: '0.9rem' }}>Description</label>
                  <textarea 
                    className="post-input" 
                    style={{ minHeight: '80px', resize: 'none' }}
                    value={newGroupDesc} 
                    onChange={(e) => setNewGroupDesc(e.target.value)} 
                    placeholder="What is this group about?"
                  />

                  <div style={{ marginTop: '20px', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                      <button onClick={() => setShowCreateModal(false)} style={{ background: 'transparent', border: '1px solid #555', color: '#aaa', padding: '10px 20px', borderRadius: '20px', cursor: 'pointer' }}>Cancel</button>
                      <button onClick={handleCreateGroup} style={{ background: '#2ed573', border: 'none', color: 'white', padding: '10px 20px', borderRadius: '20px', cursor: 'pointer', fontWeight: 'bold' }}>Create</button>
                  </div>
              </div>
          </div>
      )}

    </div>
  );
}

export default Groups;
